"use strict";

import ItemContentView from "/js/interaction-views/item-content-view.js";
import AppUtil from "/js/util/app-util.js";
import AnimSequencer from "/js/util/anim-sequencer.js";
import Constants from "/js/core/constants.js";
import FocusUtil from '/js/util/focus-util.js';

/**
 * The main content of a multiple choice item view consisting of a series of text or image buttons.
 */
export default class MultipleChoiceItemContentView extends ItemContentView {

  constructor(questionObject, index, numItems) {

    super(questionObject, index, numItems);
    
    this._correctButtonIndex = questionObject.answer;
    this._feedbackType = questionObject.feedbackType;

    // Init and append buttons
    if (questionObject.textButtons) {

      questionObject.textButtons.forEach((item, i) => {      
        const s = `\
            <div class="text-button interaction-big-button" data-index="${ i }" tabindex="${Constants.TABINDEX_CONTENT_GENERAL}"> 
              <div class="text">${ item.title }</div>
              <div class="correct"></div>
              <div class="incorrect"></div>
            </div>`;
        const $button = $(s);
        $button.click(e => this.#onButton(e));
        this.$content.append($button);
        FocusUtil.doStandardTreatment($button);
      }, this);

    } else if (questionObject.images) {

      questionObject.images.forEach((item, i) => {
        const s = `\
            <div class="image-button" data-index="${ i }" tabindex="${Constants.TABINDEX_CONTENT_GENERAL}"> 
              <img 
                  src="${ AppUtil.makeLessonAssetPath(item.url) }" 
                  alt="${ item.accessibilityDescription }">
              <div class="correct"></div>
              <div class="incorrect"></div>
            </div>`;
        const $button = $(s);
        $button.click($.proxy(this.#onButton, this));
        this.$content.append($button);
        FocusUtil.doStandardTreatment($button);
      });

    }
  }

  #onButton(e) {
    const $button = $(e.currentTarget);
    const buttonIndex = parseInt( $button.attr('data-index') );
    const isCorrect = (buttonIndex === this._correctButtonIndex);

    const sendEvent = () => {
      this.$el.trigger('content-view', isCorrect); 
    }
    const doFlash = () => {
      // "flash" the button's correct or incorrect div
      const sel = isCorrect ? ".correct" : ".incorrect";
      const $el = $button.find(sel);
      const anim = new AnimSequencer();
      anim.addAnim($el, () => { $el.addClass("fadeFromHidden"); });
      anim.addAnim($el, () => { $el.removeClass("fadeFromHidden"); $el.addClass("fadeToHidden"); });
      anim.setCallback(sendEvent);
      anim.run();
    }
    if (this._feedbackType === "flash" || this._feedbackType === "flash-constrained") {
      doFlash();
    } else {
      sendEvent();
    }
  }
}
